import { render, staticRenderFns } from "./AnnouncementSetting.vue?vue&type=template&id=3efdf468&scoped=true&"
import script from "./AnnouncementSetting.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementSetting.vue?vue&type=style&index=0&id=3efdf468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efdf468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
